import React from 'react';
import { RIGHT_OVERLAY_RESERVED_WIDTH } from '../overlayThemes/summerConstants';

const SPARKLES = [
  { left: '18%', delay: '0s', duration: '7s', size: 8 },
  { left: '30%', delay: '1.5s', duration: '9s', size: 6 },
  { left: '44%', delay: '3s', duration: '8s', size: 10 },
  { left: '58%', delay: '0.8s', duration: '10s', size: 6 },
  { left: '72%', delay: '2.2s', duration: '7.5s', size: 8 },
  { left: '86%', delay: '4s', duration: '9.5s', size: 7 },
];

export default function SummerOverlayDecorations() {
  return (
    <div className="summer-decorations" aria-hidden="true">
      <div className="summer-sparkles">
        {SPARKLES.map((s, i) => (
          <span
            key={i}
            className="summer-sparkle"
            style={{
              left: s.left,
              width: s.size,
              height: s.size,
              animationDuration: s.duration,
              animationDelay: s.delay,
            }}
          />
        ))}
      </div>

      <style>{`
        @keyframes sp-rise {
          0% { transform: translateY(0) scale(1); opacity: 0; }
          12% { opacity: 0.9; }
          100% { transform: translateY(-360px) scale(0.4); opacity: 0; }
        }

        .summer-decorations {
          position: absolute;
          inset: 0;
          pointer-events: none;
          overflow: hidden;
          z-index: 1;
        }

        .summer-sparkles {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: ${RIGHT_OVERLAY_RESERVED_WIDTH}px;
          overflow: hidden;
        }

        .summer-sparkle {
          position: absolute;
          bottom: 200px;
          background: #fff8e7;
          box-shadow: 0 0 6px #ffe66d;
          animation: sp-rise ease-in infinite;
        }
      `}</style>
    </div>
  );
}
